import React from 'react';
import '../Video.css'; 
import video from "../assets/enrobe-film_.mp4";
import image from "../assets/assainissement-min.jpeg";

const CustomVideo = ({ title }) => {
  return (
    <div className="custom-video-wrapper">
      <h2 className="custom-video-title">{title}</h2>

      {/* Vidéo pour les écrans larges */}
      <video className="custom-video" autoPlay muted loop controls>
        <source src={video} type="video/mp4" />
        Votre navigateur ne supporte pas la lecture de vidéo.
      </video>

      {/* Image pour les mobiles */}
      <img src={image} alt="Aperçu mobile" className="custom-image" />
    </div>
  );
};

export default CustomVideo;
